<template>
  <!-- 英文作文题 -->
  <div
    class="choose-topic topic-box"
    @mouseleave="showTopicEditorBox = false"
    @mouseenter="handleMouseEnter"
  >
    <!-- <TopicEditBox v-if="showTopicEditorBox" :msg="msg"></TopicEditBox> -->
    <!--<custom-edit-box v-if="!msg.resolveNum&&msg.isEdit&&!isPreview" :msg="msg" :isDis="isDis" />-->
    <div class="topic-th" v-if="msg.hasTitle">
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div v-else>
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div
      class="topic-bd fill-cont write-wrap-en"
      :style="{
        height: (msg.initDragHeight || 300) + 'px',
        border: showTopicEditorBox ? '1px solid #409eff !important' : '',
      }"
    >
      <TopicEditBox
        :msg="msg"
        v-if="showTopicEditorBox"
        position="top:5px"
      ></TopicEditBox>
      <div class="drag_mark" v-show="showTopicEditorBox"></div>
      <div
        class="html-inner ck-content"
        style="padding-top: 16px !important"
        v-if="isPreview"
        v-html="html"
      ></div>
      <template v-if="!isPreview">
        <MyUEditor
          :msg="msg"
          @onMouseEnter="showTopicEditorBox = false"
          @onMouseDown="handleMouseDown"
          @onBlur="handleBlur"
        ></MyUEditor>
      </template>
      <!-- <ckeditor v-else :editor="editor" v-model="msg.innerHTML" :config="editConfig"></ckeditor> -->
    </div>
    <div class="drag_button" id="drag_button" v-show="showTopicEditorBox">
      <i class="el-icon-rank" style="font-size: 22px"></i>
    </div>
  </div>
  <!--主体-->
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";
import { CKEDITOR_CONFIG } from "@/subjects/constant";
import FillTopic from "@/assets/js/utils/FillTopic";
import { TAG_P_HEIGHT } from "@/subjects/constant";
import MyDrag from "@/assets/js/utils/base/MyDrag";
export default {
  name: "writingEnTopic",
  props: {
    msg: Object,
    isPreview: Boolean,
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  components: {},
  data(ctx) {
    return {
      showTopicEditorBox: false,
      myFillTopic: undefined,
      myDrag: undefined,
      editConfig: CKEDITOR_CONFIG,
      isDis: false,
      resolveEnd: true,
      moveName: "writing-en-move",
      editor: ctx.$ckEditor,
      editorData: "",
      acCardYJType: ''
    };
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      blankSignal: (state) => state.blankSignal,
      existHeight: (state) => state.existHeight,
      pageCell: (state) => state.pageCell,
      subjects: (state) => state.subjects,
      currentPageNum: (state) => state.currentPageNum,
      newTopicHeight: (state) => state.newTopicHeight,
    }),
    html: function () {
      return this.msg.innerHTML.replace(
        /<p class="row underline"><\/p>/g,
        '<p class="row underline">&nbsp;</p>'
      );
    },
  },
  created() {
    // console.log(this.msg, this.editorData, this.htmlContent, "answertopic");
    // this.editor = this.$ckEditor
    // for (let i = 0; i < this.msg.typesItem.groupHArry.length; i++) {
    //   let item = this.msg.typesItem.groupHArry[i];
    //   let cont = `${item.htmlCont}`;
    //   this.htmlContent += cont;
    // }
    // this.editorData = this.htmlContent;
    // this.moveName = `writing-en-move${this.msg.pageIndex}${this.msg.topicInPageIndex}`;
  },
  mounted() {
    const target = document.querySelectorAll(".topic-bd");
    this.myDrag = new MyDrag(target);
    this.myFillTopic = new FillTopic({
      width: 1107,
      height: 706,
      canDrag: true,
      myDrag: this.myDrag,
    });
    this.myFillTopic.init();
  },
  methods: {
    ...mapMutations({
      addSubject: "card/addSubject",
      setBlankSignal: "card/setBlankSignal",
      setCurrentPageNum: "card/setCurrentPageNum",
      updatePageCell: "card/updatePageCell",
      updateSubjects: "card/updateSubjects",
    }),
    async handleBlur(data) {
      this.setCurrentPageNum(this.msg.pageIndex);
      const { editorHeight, content, overstepDistance } = data;
      await this.updatePageCell({
        currentIndexInPage: this.msg.currentIndexInPage,
        initDragHeight: editorHeight,
        innerHTML: content,
      });
      const timerUpdate = setTimeout(() => {
        let sameTopicList = []; // 把整个页面的pagecell的filltopiclist中属于该题号的题型stack存起来
        this.pageCell.forEach((page) => {
          page.fillTopiclist.forEach((topic) => {
            if (topic.th == this.msg.th) {
              sameTopicList.push(topic);
            }
          });
        });
        let subjectContainer = { initDragHeight: 0, innerHTML: "" }; // 用来存储html和高度
        this.subjects.forEach(async (subject, index) => {
          if (subject.th == this.msg.th) {
            // 题号相等的说明属于该题型的分解 然后记录下该下标
            sameTopicList.forEach((sameTopic) => {
              subjectContainer.initDragHeight += sameTopic.initDragHeight || 0; //给subject对象赋予高度
              subjectContainer.innerHTML += sameTopic.innerHTML || "";
            });
            subject.setHtml(subjectContainer.innerHTML);
            subject.setInitDragHeight(subjectContainer.initDragHeight);
            subject.setFromEdit(false);
            await this.updateSubjects({
              index: index,
              data: subject,
            });
            console.log(
              "writeEnTopic",
              sameTopicList,
              subjectContainer,
              subject,
              this.subjects
            );
          }
        });
        console.log("失焦处理的数据", this.msg, this.subjects, sameTopicList);
        clearTimeout(timerUpdate);
      }, 100);
      // 这里最好使用异步的方法处理 不影响其他代码的执行
      // 在这里处理自定义编辑的问题 blur的时候把高度 html存储到subjects里面去
      // 记录当前编辑的subject下标 循环的时候把使用下标让上面的题型保持不变 下面的题型重新appendToPage

      // const isDragFootTopicStack =
      //   this.myFillTopic.findCurrentIndexInPages(
      //     this.myDrag.currentIndexInPages
      //   ) >= this.myFillTopic.findCurrentPageFootIndex();
      const timer = setTimeout(() => {
        overstepDistance > 0 &&
          this.myFillTopic.updateViewHeight(
            overstepDistance,
            undefined,
            undefined,
            "blur"
          );
        clearTimeout(timer);
      }, 200);
    },
    handleMouseDown() {},
  },
  watch: {
    "msg.htmlArray"(val) {
      if (val.length) {
        this.editorData = val.join("");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.writing-en-cont .ck-content p,
.writing-en-cont .ck-content.ck-editor__editable_inline > :first-child {
  margin-top: 10px !important;
}

.topic-desc {
  margin: 10px 0 0 0;

  .tukuangTh {
    display: inline-block;
    margin-right: 8px;
  }

  .tukuang {
    display: inline-block;
    width: 16px;
    height: 8px;
    border: 1px solid #000;
    margin-left: 3px;
  }
}
.html-inner {
  word-break: break-word;
}
.topic-box {
  // border: 1px solid #000;
  .drag_button {
    display: none;
    position: absolute;
    bottom: 6px;
    right: 6px;
    z-index: 222222;
    pointer-events: none;
    .el-icon-rank {
      display: block;
      color: #409eff;
      cursor: n-resize;
    }
    .drag_i_active {
    }
  }
  .drag_mark {
    position: absolute;
    bottom: -30px;
    right: -30px;
    width: 80px;
    height: 80px;
    z-index: 222222;
    // cursor:s-resize;
    cursor: row-resize;
  }
  .drag_button:hover {
  }
}
.topic-box:hover .drag_button {
  display: block;
}
.topic-box:hover .topic-bd {
  border: 1px solid #409eff;
}
.topic-bd p {
  line-height: 38px;
  margin-top: 0 !important;
}
.ck-content {
  padding-top: 16px !important;
}
</style>
